module.exports = __webpack_public_path__ + "media/theme/tutorial__dmm--3--redeem-71eefe1e.png";